import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ErrorCodes} from '../../../constants/ErrorCodes';
import {UserFunctionCode} from '../../../constants/UserFunctionCode';
import {OtdsError} from '../../../models/OtdsError';
import {NotificationService} from '../../../services/notification.service';
import {OtdsErrorService} from '../../../services/otds-error.service';
import {SecurityService} from '../../../services/security.service';

@Component({
  selector: 'app-row-data-viewer',
  templateUrl: './row-data-viewer.component.html',
  styleUrls: ['./row-data-viewer.component.scss']
})
export class RowDataViewerComponent implements OnInit {

  isLoading: boolean = false;
  canView: boolean = false;

  rowData: string | null = null;

  constructor(private readonly securityService: SecurityService,
              private readonly notificationService: NotificationService,
              private readonly otdsErrorService: OtdsErrorService,
              public readonly dialogRef: MatDialogRef<RowDataViewerComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { id: number }) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.canView = this.securityService.can(UserFunctionCode.OTDS_REPROCESS);
    this.fetchData();
  }

  fetchData() {
    this.otdsErrorService.getRowData(this.data.id).subscribe({
      next: (data) => {
        this.rowData = data;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.open(ErrorCodes.OTDS_ERROR_MISSING, 'error');
        this.isLoading = false;
      }
    });
  }
}
